import React, { Component } from "react";

import data from "../../../data/cities.json";

class Service extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slidecard: data.cities
        .filter((y) => y.partnerStatus === "Active")
        .sort((a, b) => a.Order < b.Order)
        .splice(0, 3)
        .map((x) => ({ id: x.ID, heading: x.partnerName, srcimg: x.listImg })),
    };
  }

  render() {
    return (
      <div
        className="themesflat-carousel-box data-effect clearfix"
        data-gap={30}
        data-column={3}
        data-column2={2}
        data-column3={1}
        data-auto="false"
      >
        <div className="owl-carousel owl-theme">
          {this.state.slidecard.map((data) => (
            <div
              className="themesflat-image-box style-1 has-icon icon-right w65 clearfix"
              key={data.id}
            >
              <div className="image-box-item">
                <div className="inner">
                  <div className="thumb data-effect-item">
                    <a
                      href={
                        "/partner-about?id=" +
                        data.id +
                        "&name=" +
                        data.partnerName
                      }
                    >
                      <img src={data.srcimg} alt="altimage" />

                      <div className="overlay-effect bg-color-accent" />
                    </a>
                  </div>
                  <div className="text-wrap">
                    <h5 className="heading">
                      <a
                        href={
                          "/partner-about?id=" +
                          data.id +
                          "&name=" +
                          data.partnerName
                        }
                      >
                        {data.heading}
                      </a>
                    </h5>
                    <a
                      href={
                        "/partner-about?id=" +
                        data.id +
                        "&name=" +
                        data.partnerName
                      }
                    >
                      <span className="icon-wrap">
                        <i className="fa fa-angle-right" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Service;
